<template>
  <div class="container groups-selector">
    <div class="mx-2">
      <div class="groups-selector__heading">
        <h2 class="flow-heading mt-5 mb-3">{{ heading }}</h2>

        <p>
          <slot name="subheading"></slot>
        </p>
      </div>

      <p v-if="!allGroups.length" class="groups-selector__nogroups">There are no groups in your CRM</p>

      <template v-else>
        <flow-search
          @input="search = $event"
          @toggle-all="onToggleAll"
          :search="search"
          placeholder="Search by group name"
          :everySelected="everySelected"
        ></flow-search>

        <form class="text-center">
          <div class="groups-selector__list">
            <flow-groups
              :groups="filteredGroups"
              :selectedGroupsIds="selectedGroupsIds"
              @toggle-item="onToggleGroup"
            ></flow-groups>
          </div>
          <div>
            <slot></slot>
          </div>
        </form>
      </template>
    </div>
  </div>
</template>

<script>
import FlowGroups from './FlowGroups';
import FlowSearch from './FlowSearch';

export default {
  name: 'sync-groups-selector-page',
  components: {
    FlowGroups,
    FlowSearch,
  },
  data() {
    return {
      search: '',
      selectedGroupsIds: [],
    };
  },
  methods: {
    onToggleGroup(id) {
      this.selectedGroupsIds = this.selectedGroupsIds.includes(id)
        ? this.selectedGroupsIds.filter(item => item !== id)
        : [...this.selectedGroupsIds, id];
    },
    onToggleAll() {
      this.selectedGroupsIds = this.everySelected
        ? this.selectedGroupsIds.filter(id => !this.filteredGroupsIds.includes(id))
        : this.filteredGroups.map(group => group.id);
    },
  },
  computed: {
    allGroups() {
      const groups = JSON.parse(this.groups);
      return groups.filter(group => group.name !== this.excludedGroup);
    },
    filteredGroups() {
      return Array.isArray(this.allGroups)
        ? this.allGroups.filter(group => group.name.toLowerCase().includes(this.search.toLowerCase()))
        : [];
    },
    filteredGroupsIds() {
      return this.filteredGroups.map(group => group.id);
    },
    everySelected() {
      return this.filteredGroups.every(group => this.selectedGroupsIds.includes(group.id));
    },
  },
  props: {
    heading: {
      type: String,
    },
    excludedGroup: {
      type: String,
    },
    groups: {
      type: String,
      required: true,
    },
    preselectedGroups: {
      type: Array,
    },
  },
  created() {
    if (this.preselectedGroups) this.selectedGroupsIds = this.preselectedGroups;
  },
  watch: {
    selectedGroupsIds(val) {
      this.$emit('selected', val);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../sass/web/_variables.scss';
.groups-selector {
  background: $white-color;
  &__heading {
    max-width: 733px;
    margin: 0 auto;
    text-align: center;
  }
  &__nogroups {
    width: 70%;
    margin: 10px auto 40px;
    border: 2px solid $red-color;
    border-radius: 4px;
  }
  &__list {
    max-height: 272px;
    margin: 30px auto;
  }
}
</style>
